export const OUTLINE_RECEIVED = 'OUTLINE_RECEIVED';
export const OUTLINE_UPDATED = 'OUTLINE_UPDATED';

export const COMPONENT_ADDED = 'COMPONENT_ADDED';
export const COMPONENT_UPDATED = 'COMPONENT_UPDATED';
export const COMPONENT_DELETED = 'COMPONENT_DELETED';
export const COMPONENT_SELECTED = 'COMPONENT_SELECTED';

export const EDITOR_CLOSE = 'EDITOR_CLOSE';
export const EDITOR_OPEN = 'EDITOR_OPEN';
export const EDITOR_TAB_SELECT = 'EDITOR_TAB_SELECT';
export const EDITOR_UPDATE_HEIGHT = 'EDITOR_UPDATE_HEIGHT';
export const EDITOR_UPDATE_WIDTH = 'EDITOR_UPDATE_WIDTH';
export const EDITOR_UPDATE_DOCK = 'EDITOR_UPDATE_DOCK';

export const ADD_REPEATABLE = 'ADD_REPEATABLE';
export const MOVE_REPEATABLE = 'MOVE_REPEATABLE';
export const DELETE_REPEATABLE = 'DELETE_REPEATABLE';
export const DUPLICATE_REPEATABLE = 'DUPLICATE_REPEATABLE';
export const DUPLICATE_GRID_ITEM_COMPONENT = 'DUPLICATE_GRID_ITEM_COMPONENT';
export const BUILDER_LOADED = 'BUILDER_LOADED';

export const SHOULD_WATCH_QUERY_PARAMS = 'SHOULD_WATCH_QUERY_PARAMS';

export const ALWAYS_RENDER_IN_BUILDER = 'ALWAYS_RENDER_IN_BUILDER';

export const TOGGLE_BADGE = 'TOGGLE_BADGE';
export const CLOSE_ALL_BADGES = 'CLOSE_ALL_BADGES';

export const START_SORTING = 'START_SORTING';
export const STOP_SORTING = 'STOP_SORTING';
export const MOVE_COMPONENT = 'MOVE_COMPONENT';

export const SET_BUILDER_VERSION = 'SET_BUILDER_VERSION';

export const RAW_UPDATE = 'RAW_UPDATE';

export const START_LOADING = 'START_LOADING';
export const DONE_LOADING = 'DONE_LOADING';

export const EDITOR_SHOW_ALL_VIEW_PORTS = 'EDITOR_SHOW_ALL_VIEW_PORTS';
export const EDITOR_TOGGLE_ALL_VIEW_PORTS = 'EDITOR_TOGGLE_ALL_VIEW_PORTS';
export const EDITOR_CHANGE_MOBILE_EXPERIENCE_VIEW =
  'EDITOR_CHANGE_MOBILE_EXPERIENCE_VIEW';
